import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

const commonPermissions = [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CDC_TIER1_METRICS];

export const HELIX_UHN_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [...commonPermissions, Permissions.CAN_VIEW_PHI],
  [UserRole.EXECUTIVE]: commonPermissions,
  [UserRole.MEMBER_LIMITED_PHI]: commonPermissions,
  [UserRole.MEMBER]: [...commonPermissions, Permissions.CAN_VIEW_PHI],
};
